
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.771 4.474c-.288-.47-.906-.621-1.348-.291a11 11 0 00-1.108.947c-.395.385-.342 1.019.078 1.377.419.358 1.046.303 1.448-.074.202-.19.413-.37.632-.54.435-.339.587-.95.298-1.42zM17.229 4.474c.288-.47.906-.621 1.348-.291.39.29.76.607 1.108.947.395.385.342 1.019-.078 1.377-.419.358-1.046.303-1.448-.074a8.995 8.995 0 00-.632-.54c-.435-.339-.587-.95-.299-1.42z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 3a1 1 0 011-1h4a1 1 0 110 2h-1v1.062A8.001 8.001 0 0112 21a8 8 0 01-1-15.938V4h-1a1 1 0 01-1-1zm6.707 6.293a1 1 0 010 1.414l-1.775 1.775a2 2 0 11-1.414-1.414l1.775-1.775a1 1 0 011.414 0z"}})])
          )
        }
      }
    